import { render, staticRenderFns } from "./crtmark.vue?vue&type=template&id=ccd1878a&scoped=true&"
import script from "./crtmark.vue?vue&type=script&lang=js&"
export * from "./crtmark.vue?vue&type=script&lang=js&"
import style0 from "./crtmark.vue?vue&type=style&index=0&id=ccd1878a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd1878a",
  null
  
)

export default component.exports